import { PathSegments } from '../../abstract/path-segments';

/** `admin/organizations/{id}` as path segments, for admin org sub-resources (`{ prefix: adminOrgPrefix(id) }`). */
export function adminOrgPrefix(organizationId: string): PathSegments {
  return ['admin', 'organizations', organizationId];
}
